var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16999 15.5794C8.97999 15.5794 8.78999 15.5094 8.63999 15.3594C8.34999 15.0694 8.34999 14.5894 8.63999 14.2994L14.3 8.63938C14.59 8.34938 15.07 8.34938 15.36 8.63938C15.65 8.92937 15.65 9.40937 15.36 9.69937L9.69998 15.3594C9.55998 15.5094 9.35999 15.5794 9.16999 15.5794Z",
    fill: "#C90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.83 15.5794C14.64 15.5794 14.45 15.5094 14.3 15.3594L8.63999 9.69937C8.34999 9.40937 8.34999 8.92937 8.63999 8.63938C8.92999 8.34938 9.40998 8.34938 9.69998 8.63938L15.36 14.2994C15.65 14.5894 15.65 15.0694 15.36 15.3594C15.21 15.5094 15.02 15.5794 14.83 15.5794Z",
    fill: "#C90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#BFC3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/CloseSquare.70a4f1d2.svg";
export { ForwardRef as ReactComponent };